import { Linking } from 'react-native';
import { getStreamFromContent } from '@annunciate/download';
export const onOpenExternalLink = async (client, content) => {
    const streamable = await getStreamFromContent(content, client);
    if (streamable.stream) {
        Linking.openURL(streamable.stream);
    }
};
//# sourceMappingURL=onOpenExternalLink.js.map